(() => {
  if (window.__PVF_INIT__) return
  window.__PVF_INIT__ = true

  const handle = window.__PRODUCT_HANDLE__
  if (!handle) {
    console.warn('[PVF] Missing window.__PRODUCT_HANDLE__')
    return
  }

  async function fetchAllVariantsRobust() {
    let allVariants = []
    let page = 1

    while (true) {
      try {
        const url = `/products/${handle}.js${page > 1 ? `?page=${page}` : ''}`
        const response = await fetch(url, { cache: 'no-store' })

        if (!response.ok) break

        const data = await response.json()
        const variants = data.variants || []

        if (variants.length === 0) break

        allVariants = allVariants.concat(variants)

        // If we got less than 250, this is the last page
        if (variants.length < 250) break

        page += 1
      } catch (error) {
        console.error(`[PVF] Error fetching page ${page}:`, error)
        break
      }
    }

    return allVariants
  }

  // Expose promise + storage
  window.__variantsPromise__ = fetchAllVariantsRobust()
    .then((variants) => {
      window.allVariants = variants || []
      window.__ALL_VARIANTS_READY__ = true
      return window.allVariants
    })
    .catch((err) => {
      console.error('[PVF] Variants fetch failed:', err)
      window.allVariants = window.allVariants || []
      return window.allVariants
    })
})()